<!-- eslint-disable vue/multi-word-component-names -->
<!-- Landing Page -->
<template>
  <page-layout>
    <div class="header3">
      “Polly Dugan’s stories read like whispered secrets. With their quiet
      drama, their nuanced internal conflicts, their characters full of longing,
      they immerse us in the messy mysteries of ordinary lives. But their vision
      is clear-headed and generous: they show us that even our briefest
      connections, our smallest actions, our most private thoughts, can have
      great weight and consequence.”
    </div>
    <h5>—Scott Nadelson, author of <em>Aftermath</em></h5>
    <divider />
    <h3 class="header">Featured Works</h3>
    <image-box :covers="coverImages" />
    <divider />
    <div class="content-wrapper">
      <div class="left">
        <image-box author :image="authorImage" alt="Polly Dugan" />
      </div>
      <div class="right">
        <p class="paragraph">
          Polly Dugan is the author of the linked story collection,
          <em>So Much a Part of You</em>, and the novels,
          <em>The Sweetheart Deal</em> and <em>The House of Cavanaugh</em>. Her
          short fiction has appeared in Narrative and Line Zero. She is a
          contributing author to
          <em
            >Before and After the Book Deal: A Writer’s Guide to Finishing,
            Publishing, Promoting, and Surviving Your First Book</em
          >
          by Courtney Maum. She is a graduate of Dickinson College, a former
          employee of Powell’s Books and Guide Dogs for the Blind, a Tin House
          Workshop alumna and a former submissions reader for Tin House
          magazine. She lives in Portland and Manzanita, Oregon with her family.
        </p>
      </div>
    </div>
  </page-layout>
</template>

<script>
// import components
import PageLayout from "@/components/global-styles/layout/PageLayout.vue";
import Divider from "@/components/global-styles/default/Divider.vue";
import ImageBox from "@/components/global-styles/components/ImageBox.vue";

// import images
import authorImage from "@/assets/author-wide.jpg";
import thocCover from "@/assets/images/book-covers/THOCCover.jpg";
import tsdCover from "@/assets/images/book-covers/TSDCover.jpg";
import smapoyCover from "@/assets/images/book-covers/SMAPOYCover.jpg";

export default {
  name: "LandingPage",
  components: {
    PageLayout,
    Divider,
    ImageBox,
  },
  data() {
    return {
      coverImages: [
        {
          image: thocCover,
          alt: "The House of Cavanaugh",
          path: "/books/thoc",
        },
        {
          image: tsdCover,
          alt: "The Sweetheart Deal",
          path: "/books/tsd",
        },
        {
          image: smapoyCover,
          alt: "So Much a Part of You",
          path: "/books/smapoy",
        },
      ],
      authorImage: authorImage,
    };
  },
};
</script>

<style scoped>
.header3 {
  font-size: 1.5em;
  padding: 1.5em;
  text-align: center;
  font-family: PT Serif, serif;
}

.header {
  padding: 1rem 0;
  text-align: center;
}

.paragraph {
  font-size: 1.09em;
  color: black;
  margin: 0;
  padding-left: 1em;
  padding-right: 5em;
  line-height: 1.6;
  padding-bottom: 0.5em;
  padding-top: 0em;
  font-family: PT Serif, serif;
}

.content-wrapper {
  display: flex;
  flex-direction: row;
}

.left {
  float: left;
  width: 50%;
  box-sizing: border-box;
  padding: 0.5em;
  padding-top: 1em;
  display: flex;
  justify-content: flex-end;
}

.right {
  float: right;
  width: 50%;
  box-sizing: border-box;
  padding: 0.5em;
  padding-top: 1em;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* Large Tablets and Small Desktops - 1024px and below */
@media (max-width: 1024px) {
  .header3 {
    font-size: 1.4em;
    padding: 1.3em;
  }

  .paragraph {
    padding-right: 3em;
    font-size: 1.05em;
  }
}

/* Standard Tablets - 768px and below */
@media (max-width: 768px) {
  .header3 {
    font-size: 1.3em;
    padding: 1em 0;
  }

  .paragraph {
    padding: 0 1em;
    font-size: 1em;
    text-align: justify;
  }

  .content-wrapper {
    flex-direction: column;
    align-items: center;
  }

  .left,
  .right {
    width: 100%;
    padding: 1em 0;
    align-items: center;
    float: none;
  }
}

/* Small Mobile Phones - 360px and below */
@media (max-width: 360px) {
  .header3 {
    font-size: 1em;
    padding: 0.5em 0;
    line-height: 1.3;
  }

  h5 {
    font-size: 0.9em;
  }

  .paragraph {
    font-size: 0.85em;
    padding: 0 0.5em;
    line-height: 1.3;
  }
}

/* Extra Small Phones - 320px and below */
@media (max-width: 320px) {
  .header3 {
    font-size: 0.95em;
    padding: 0.4em 0;
    line-height: 1.25;
  }

  .paragraph {
    font-size: 0.8em;
    padding: 0 0.4em;
    line-height: 1.25;
  }
}
</style>
